// Bug 17/50 — Matrice Eisenhower · derivazione label + colori + preset
// Solo 3 label visibili (Costruisci/Gestisci/Risolvi). La quarta combinazione
// (not_important + not_urgent) è nascosta dalla Home per rispettare la scelta
// prodotto: cose "senza importanza né urgenza" NON hanno spazio principale.

export const EISENHOWER_LABELS = {
  costruisci: "Costruisci", // important + not_urgent
  gestisci:   "Gestisci",   // important + urgent
  risolvi:    "Risolvi",    // not_important + urgent
  hidden:     null,          // not_important + not_urgent → non mostrare in Home
};

// Colori/badge dedicati (evitando pattern AI-slop viola-gradient su bianco).
export const EISENHOWER_META = {
  costruisci: { label: "Costruisci", cls: "bg-emerald-100 text-emerald-800", tone: "growth" },
  gestisci:   { label: "Gestisci",   cls: "bg-red-100 text-red-800",         tone: "urgent-important" },
  risolvi:    { label: "Risolvi",    cls: "bg-amber-100 text-amber-800",     tone: "friction" },
};

/** Deriva la chiave Eisenhower dai campi `importance` + `urgency`. */
export function eisenhowerKey(importance, urgency) {
  if (importance === "important" && urgency === "not_urgent") return "costruisci";
  if (importance === "important" && urgency === "urgent")     return "gestisci";
  if (importance === "not_important" && urgency === "urgent") return "risolvi";
  return null;
}

/** Retro-compat: se un task non ha ancora importance/urgency, mappa dal
 *  vecchio `priority` (usato pre-Bug 17). Ritorna la chiave Eisenhower. */
export function eisenhowerKeyFromTask(task) {
  if (!task) return null;
  const direct = eisenhowerKey(task.importance, task.urgency);
  if (direct) return direct;
  // Se sono valorizzati come "not_important + not_urgent" → nascosto (null).
  if (task.importance === "not_important" && task.urgency === "not_urgent") return null;
  // Fallback dal vecchio priority (solo se importance/urgency null).
  if (!task.importance && !task.urgency) {
    switch (task.priority) {
      case "critical": return "gestisci";
      case "high":     return "costruisci";
      case "medium":   return "risolvi";
      default:         return null; // low → nascosto
    }
  }
  return null;
}

/** Payload PATCH/POST: dai una chiave, ottieni i due campi da salvare. */
export function eisenhowerToPayload(key) {
  switch (key) {
    case "costruisci": return { importance: "important",     urgency: "not_urgent" };
    case "gestisci":   return { importance: "important",     urgency: "urgent" };
    case "risolvi":    return { importance: "not_important", urgency: "urgent" };
    case "nessuna":    return { importance: "not_important", urgency: "not_urgent" };
    default:            return { importance: null,             urgency: null };
  }
}

/** Nasconde dalla Home task con Eisenhower key null (o "nessuna" esplicita). */
export function shouldShowInHome(task) {
  return eisenhowerKeyFromTask(task) !== null;
}
